import { behavioralFields } from './behaviour-fields'
import { lookFeelFields } from './lookfeel-fields'
export { default as WhiteLabelFormSection } from './WhiteLabelFormSection/WhiteLabelFormSection'
export { default as WhiteLabelFormWelcomeText } from './WhiteLabelFormWelcomeText/WhiteLabelFormWelcomeText'

export const forms = {
  behavioralFields,
  lookFeelFields
}
